<template>
	<div class="title-panel-container">
		<div class="title-name">
			<slot name="left"></slot>
		</div>
		<div class="control-container">
			<slot name="right"></slot>
		</div>
	</div>
</template>

<script>
	import {defineComponent} from "vue"
	
	export default defineComponent({
		name: "titlePanel"
	})
</script>

<style lang="scss" scoped="scoped">
	@import "~@/assets/styles/_handle.scss";

	.title-panel-container {
		height: 60px;
		display: flex;
		align-items: center;
		align-content: center;
		width: 100%;
		justify-content: space-between;

		.title-name {
			height: 100%;
			line-height: 16px;
			font-size: 16px;
			width: auto;
			@include font_color("title-panel-font-color");
			@include font_family("font_family");
			display: flex;
			align-items: center;
			align-content: center;
		}

		.control-container {
			width: auto;
			height: 100%;
			display: flex;
			align-items: center;
			align-content: center;
			box-sizing: border-box;
		}
	}
</style>
